/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Created_HeaderInputs */

const en_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const fr_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const de_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const it_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const ru_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const es_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const zh_cn2_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const ja_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const hi_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const pt_pt2_explorer_search_created_header = /** @type {(inputs: Explorer_Search_Created_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Explorer_Search_Created_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_created_header = /** @type {((inputs?: Explorer_Search_Created_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Created_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_created_header(inputs)
	if (locale === "de") return de_explorer_search_created_header(inputs)
	if (locale === "it") return it_explorer_search_created_header(inputs)
	if (locale === "ru") return ru_explorer_search_created_header(inputs)
	if (locale === "es") return es_explorer_search_created_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_created_header(inputs)
	if (locale === "ja") return ja_explorer_search_created_header(inputs)
	if (locale === "hi") return hi_explorer_search_created_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_created_header(inputs)
	return en_explorer_search_created_header(inputs)
});